const getter = {
  code: state => state.common.code,
}

export default getter;